"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineUser = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
/**
 * LINEユーザー情報を取得するカスタムフック
 * @returns LineUser, LineUserLoading
 */
var useLineUser = function (redirect_uri) {
    var _a = (0, react_1.useState)(), LineUser = _a[0], setLineUser = _a[1];
    var _b = (0, react_1.useState)(true), LineUserLoading = _b[0], setLineUserLoading = _b[1];
    var navigate = (0, react_router_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/line/user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(function (data) {
            setLineUser(data.data);
        })
            .catch(function (_a) {
            var response = _a.response;
            if (redirect_uri)
                navigate(redirect_uri);
        })
            .finally(function () {
            setLineUserLoading(false);
        });
    }, []);
    return { LineUser: LineUser, LineUserLoading: LineUserLoading };
};
exports.useLineUser = useLineUser;
